import { deleteArtisanPostApi, fetchArtisanFollowersApi, fetchArtisanPostsApi, fetchPosts, fetchSavedPosts, fetchSubscribedPostsApi, newPost, savePost, unsavePost } from "../api/feed.api";

export const fetchArtisanFollowersService = async () => {
    const data = await fetchArtisanFollowersApi();
    return data.followers;
};

export const fetchPostsService = async(activeTab,searchParams)=>{
    const data = await fetchPosts(activeTab,searchParams);
    return data.posts;
};

export const savePostService = async(postId)=>{
    return await savePost(postId);
}

export const unsavePostService = async(postId)=>{
    return await unsavePost(postId);
}

export const newPostService = async(formData)=>{
    return await newPost(formData);
}

export const fetchSavedPostsService = async()=>{
    const data = await fetchSavedPosts();
    return data.savedPost;
}

export const fetchSubscribedPostsService = async(activeTab,followedFilters)=>{
    const data = await fetchSubscribedPostsApi(activeTab,followedFilters);
    return data.posts;
}

export const fetchArtisanPostsService = async(artisanId)=>{
    const data = await fetchArtisanPostsApi(artisanId);
    return data.posts;
}

export const deleteArtisanPostService = async(postId)=>{
    return await deleteArtisanPostApi(postId);
}
